import { Toastr } from "../../../revvComponents";
import { addTemplateComponentService } from "../../../actions/DocumentTemplateActions/templateService";
import DocTemplateBaseCommand from "./docTemplateBaseCommand";

import { DOCUMENTS } from "../../../constants";
import { DOCUMENT_MODE } from "../../../constants/document";

const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class AddTemplateComponentCommand extends DocTemplateBaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  addComponentInTemplateService = (docNo, docID, componentPayload, component) =>
    new Promise((resolve, reject) => {
      if (component.type === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER) {
        this.componentData.updateAddComponentinToolbarAction(
          DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER,
        );
      }

      if (component.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
        this.componentData.autoUpdateTitle(DOCUMENT_MODE.TEMPLATE, docID);
      }

      addTemplateComponentService(docNo || docID, [componentPayload])
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          console.error(`Document => _addNewComponent => Error : ${error}`);
          Toastr.showToastr({
            type: "failure",
            message: "Oops, Something went wrong!!",
            timeout: 3000,
          });

          setTimeout(() => {
            this.componentData.deleteDocumentComponentAction(component.id);
          }, 2000);
          reject(error);
        });
    });

  saveToDatabase(componentPayload) {
    const { docID, docNo, component } = this.componentData;
    return new Promise((resolve, reject) => {
      this.addComponentInTemplateService(
        docNo,
        docID,
        componentPayload,
        component,
      )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  execute() {
    super.execute();
    if (!this.isRedo) {
      // Save to db
      const componentPayload = super.getComponentPayload();
      this.saveToDatabase(componentPayload)
        .then(() => {})
        .catch(() => {});
    }
  }

  undo() {
    super.undo();
  }
}

export default AddTemplateComponentCommand;
